import React, { useEffect, useState } from "react";
import '../../assets/css/style.css';
import Header from "./header";
import Sidebar from "./sidebar";
import Footer from "./footer";
import Loader from "../Loader";

const Master = ({ children }) => {

    const [loading, setLoading] = useState(false)
    return (
        <div className="main-container">
            {loading && (
                <div className="overlay" style={{ zIndex: "999999" }}>
                    <div className="loader-wrapper">
                        <Loader height={120} width={120} />
                    </div>
                </div>
            )}
            <div className="main-header">
                <div className="header">
                    <Header />
                </div>
            </div>
            <div className="content-container">
                <div className="sidebar">
                    <Sidebar setLoading={setLoading} />

                </div>
                <div className="content-section">
                    <div className="content">
                        {/* <MarqueeMessage /> */}
                        {children}
                    </div>
                    <Footer />
                </div>
            </div>
            {/* <div className="footer">
                
            </div> */}
        </div>
    );

};

export default Master;
